<template>
  <div class="ecSearch">
    <Row :gutter="4">
      <!-- 选择公司 -->
      <div v-if="company==1">
        <Col span="4">
          <Select v-model="companyId" filterable :placeholder="$t('alarms.common.pleaseSelectCompany')" :transfer="true" @on-change="searchCompany">
            <Option value="" selected>{{ $t('alarms.common.all') }}</Option>
            <Option :value="item.id" v-for="item in companyList" :key="item.id">{{item.name}}</Option>
          </Select>
        </Col>
      </div>
      <Col span="4">
        <Select v-model="accountId" filterable :placeholder="$t('alarms.common.pleaseSelectAccount')" :transfer="true" @on-change="searchAccount">
          <Option value="" selected>{{ $t('alarms.common.all') }}</Option>
          <Option :value="item.id" v-for="item in accountList" :key="item.id">{{item.name}}</Option>
        </Select>
      </Col>
      <Col span="4">
        <Select v-model="stateId" filterable :placeholder="$t('alarms.common.pleaseSelectStatus')" :transfer="true" @on-change="searchState">
          <Option value="" selected>{{ $t('alarms.common.all') }}</Option>
          <Option :value="item.id" v-for="item in stateList" :key="item.id">{{item.name}}</Option>
        </Select>
      </Col>
      <Col span="4">
        <Select v-model="typeId" filterable :placeholder="$t('alarms.common.pleaseSelectCategory')" :transfer="true" @on-change="searchType">
          <Option value="" selected>{{ $t('alarms.common.all') }}</Option>
          <Option :value="item.id" v-for="item in typeList" :key="item.id">{{item.name}}</Option>
        </Select>
      </Col>
      <Col span="4">
        <Select v-model="delayTypeId" filterable :placeholder="$t('alarms.common.pleaseSelectDelayType')" :transfer="true" @on-change="searchDelayType">
          <Option value="" selected>{{ $t('alarms.common.all') }}</Option>
          <Option :value="item.id" v-for="item in delayTypeList" :key="item.id">{{item.name}}</Option>
        </Select>
      </Col>
<!--      <Col span="4">-->
<!--        <Select v-model="ruleName" filterable :placeholder="$t('BillingServices.Querybyrulename')" :transfer="true" @on-change="searchRuleName">-->
<!--          <Option value="" selected>{{ $t('alarms.common.all') }}</Option>-->
<!--          <Option :value="item.id" v-for="item in delayTypeList" :key="item.id">{{item.name}}</Option>-->
<!--        </Select>-->
<!--      </Col>-->
    </Row>
  </div>
</template>
<script>
  import TableElasticComputeCloudWarning from '../ec2/TableElasticComputeCloudWarning'
  import {setCookie,getCookie} from '../../../utils/cookieUtil.js'

  const tableElasticComputeCloudWarning = TableElasticComputeCloudWarning;
  export default {
    name: 'ElasticComputeCloudMonitorAlertRuleSearch',
    data () {
      return {
        tag:'',
        region: [],
        instanceId:'',
        regionList:[],
        regionName:'',
        privateIp:'',
        instanceName: '',
        accountId: '',
        accountName: '',
        accountType: '',
        accountList: [],
        company: getCookie(global.companyId),
        companyId: '',
        companyList: [],
        stateList:[
            {
                id: 1,
                name: this.$t('alarms.common.disable')
            },
            {
                id: 0,
                name: this.$t('alarms.common.enable')
            }
        ],
        stateId: '',
        delayTypeId: '',
        typeList:[
            {
                id: 0,
                name: this.$t('alarms.common.manual')
            },
            {
                id: 1,
                name: this.$t('alarms.common.automatic')
            }
        ],
          typeId:'',
        delayTypeList:[]

      }
    },
    mounted: function(){
      if (this.company == 1) {
        this.getCompanyDropDownBox();
      } else {
        this.getAccountDropDownBox();
      }
      this.getAlarmDelay();
    },
    methods: {
      // 获取公司下拉框
      getCompanyDropDownBox: function(){
        this.$api.company.getCompanyDropDownBox("userName",getCookie(global.cookieName))
          .then(res => {
            this.companyList = res.data;
          });
      },
      // 根据用户名查询Account下拉列表
      getAccountDropDownBox: function () {
        this.$api.account.queryAccountsByCompanyId("companyId", (this.companyId == null || this.companyId == '' || this.companyId == undefined) ? this.company : this.companyId)
          .then(res => {
            this.accountList = res.data;
            for (let i = 0; i < this.accountList.length; i++) {
              switch(this.accountList[i].type){
                case 0:
                  this.accountList[i].name = this.accountList[i].name + '(AWS)';
                  break;
                case 1:
                  this.accountList[i].name = this.accountList[i].name + '(Aliyun)';
                  break;
                case 2:
                  this.accountList[i].name = this.accountList[i].name + '(Azure)';
                  break;
                default:
                  this.accountList[i].name = this.accountList[i].name;
                  break
              }

            }
          });
      },
      // 查询报警延迟
      getAlarmDelay: function () {
        this.$api.alertRule.alarmDelay("userName", getCookie(global.cookieName))
          .then(res => {
            this.delayTypeList = res.data;
          })
      },
      // 按公司搜索
      searchCompany: function(){
        // 在需要传递参数的组件中，定义一个emit发送需要传递的值，键名可以自己定义（可以为对象）
        eventBus.$emit('companyId', this.companyId);
        this.getAccountDropDownBox();
        tableElasticComputeCloudWarning.methods.showAll();
      },
      // 按账户搜索
      searchAccount: function(){
        eventBus.$emit('accountId', this.accountId);
        tableElasticComputeCloudWarning.methods.showAll();
      },
      // 按状态筛选
      searchState: function(){
        eventBus.$emit('stateId', this.stateId);
        tableElasticComputeCloudWarning.methods.showAll();
      },
      // 按类型筛选
      searchType: function(){
        eventBus.$emit('typeId', this.typeId);
        tableElasticComputeCloudWarning.methods.showAll();
      },
      // 按延迟类型筛选
      searchDelayType: function(){
        eventBus.$emit('delayTypeId', this.delayTypeId);
        tableElasticComputeCloudWarning.methods.showAll();
      }
    }
  }
</script>
<style scoped>
  .ecSearch
  {
    height: 51px;
  }
</style>



// WEBPACK FOOTER //
// src/components/monitor/ec2/ElasticComputeCloudMonitorAlertRuleSearch.vue